
import React from 'react';
import { Button } from '../ui/Button';

const OAuthConsent: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="mx-auto h-12 w-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
             <svg className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
             </svg>
        </div>
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          Authorization Request
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Application <strong>AGM Portal</strong> is requesting access to your account.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
             <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4">
                <div className="flex">
                  <div className="ml-3">
                    <p className="text-sm text-indigo-700">
                      <strong>Preview Mode:</strong> This is a standard OAuth consent screen verification page.
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-4">
                  <h3 className="text-sm font-medium text-gray-900">Requested Permissions:</h3>
                  <ul className="mt-2 text-sm text-gray-500 list-disc list-inside space-y-1">
                      <li>View your basic profile info</li>
                      <li>View your email address</li>
                      <li>Manage your order history</li>
                  </ul>
              </div>
              
              <div className="flex justify-between items-center gap-4 pt-4">
                  <Button variant="secondary" className="w-full" onClick={() => window.location.href = '/'}>
                    Cancel
                  </Button>
                  <Button className="w-full" onClick={() => window.location.href = '/'}>
                    Authorize
                  </Button>
              </div>
              
              <p className="text-xs text-center text-gray-400 mt-4">
                  You will be redirected back to the application upon authorization.
              </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OAuthConsent;
